import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const useGetTenantsQuery = () => {
  const { getTenants } = useServicesContext();

  return useQuery({
    queryKey: ['GET_TENANTS'],
    queryFn: getTenants,
  });
};
